import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';
import { useCurrentBusinessId } from './useCurrentBusinessId';

/**
 * A hook that uses a cache-first policy to retrieve channel list items.
 */
export function useChannelsLite(): { channels: API.ChannelListItemFragment[]; loading: boolean } {
  const businessId = useCurrentBusinessId();
  const { data, loading } = useQuery<API.ChannelListQuery, API.ChannelListQueryVariables>(
    Queries.channel.list,
    {
      variables: { businessId: businessId ?? -1 },
      skip: !businessId,
      fetchPolicy: 'cache-first',
    },
  );

  return useMemo(
    () => ({
      channels: data?.me?.business?.channels?.filter(notNil) ?? [],
      loading,
    }),
    [data?.me?.business?.channels, loading],
  );
}
